import { useMemo } from "react";
import { useTherapyColors } from "../stores/MasterTables/masterTables.queries";

/**
 * The therapy colour map — a flat Record<catalogId, hex> sourced entirely from
 * the backend catalog (GetTherapyColors, 12h cache). The static theme map it
 * used to layer over is gone; the catalog is the single source of truth.
 *
 * MD-232: keys are IDENTITIES, not display text — TherapyMethod ids for
 * scheduled slots, PrescribedTherapy ids for unscheduled ones. Derive the key
 * with `therapyColorKey(slot)`; never index this map with an abbreviation,
 * shortLabel or label. Those are renameable, and keying on them is what made
 * renamed Heilmittel render grey (D-RX-05). An id with no curated colour is
 * simply absent — callers handle that with their own `|| "grey"` fallback,
 * which is also what renders during the first fetch.
 */
export const useTherapyColorMap = (): Record<string, string> => {
  const { data } = useTherapyColors();
  return useMemo(() => data ?? {}, [data]);
};

export default useTherapyColorMap;
